import { render, staticRenderFns } from "./GreatEventIndex.vue?vue&type=template&id=46b96412&scoped=true"
import script from "./GreatEventIndex.vue?vue&type=script&lang=js"
export * from "./GreatEventIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b96412",
  null
  
)

export default component.exports